import { assert } from 'chai';
import httpMocks from 'node-mocks-http';

import checkPublicIP from './checkPublicIP';

describe('checkPublicIP', () => {
    it('should call next() on valid IP', (done) => {
        const req = httpMocks.createRequest({ body: { publicIp: '123.123.123.123' } });
        const res = httpMocks.createResponse();
        checkPublicIP(req, res, done);
    });

    it('should return 400 without IP', () => {
        const req = httpMocks.createRequest({ body: {} });
        const res = httpMocks.createResponse();
        checkPublicIP(req, res);
        assert.equal(400, res._getStatusCode()); // eslint-disable-line no-underscore-dangle
    });

    it('should return 400 with Private IP', () => {
        const req = httpMocks.createRequest({ body: { publicIp: '192.168.0.1' } });
        const res = httpMocks.createResponse();
        checkPublicIP(req, res);
        assert.equal(400, res._getStatusCode()); // eslint-disable-line no-underscore-dangle
    });

    it('should return 400 with Malformed IP', () => {
        const req = httpMocks.createRequest({ body: { publicIp: '192.168' } });
        const res = httpMocks.createResponse();
        checkPublicIP(req, res);
        assert.equal(400, res._getStatusCode()); // eslint-disable-line no-underscore-dangle
    });
});
